import { Route,Routes } from 'react-router-dom';
import { PrivateRoute, privateRoutes } from 'services/privateRoute.utils';
import { Login } from 'pages/Login/Login';
import NoMatchFound from 'pages/NoMatchFound/NoMatchFound';
import NoDataAvailable from 'pages/NoDataAvailable/NoDataAvailable';
import NoDataAndDisconnected from 'pages/NoDataAndDisconnected/NoDataAndDisconnected';
import ModalPage from 'pages/ModalPage/ModalPage';
import PageNotFound from 'pages/404page/PageNotFound';
import useRehydrate from 'hooks/useRehydrate';
import PageAccessDenied from 'pages/AccessDenied/PageAccessDenied';

import './App.css';

function App() {
  useRehydrate()
  
  return (
    <div>
      <Routes>
        {privateRoutes?.map((item, i) => {
          return (
            <Route
              key={i}
              path={item?.route}
              caseSensitive
              element={<PrivateRoute requiredModule={item.requiredModule}>{item.component}</PrivateRoute>}
            />
          );
        })}
        <Route exact path='/' element={<Login/>}	/>  
        <Route exact path='/nomatchfound' element={<NoMatchFound/>}/>
        <Route exact path='/nodata' element={<NoDataAvailable/>}/>
        <Route exact path='/disconnectednodata' element={<NoDataAndDisconnected/>}/>
        <Route exact path='/modalpage' element={<ModalPage/>}/>
        <Route exact path='/*' element={<PageNotFound/>}/>
        <Route exact path='/NoAccess' element={<PageAccessDenied/>} />
      </Routes>
    </div>
  );
}

export default App;
